import { render } from "./TheWarehouse.vue?vue&type=template&id=27e5ffd0&scoped=true&lang=true"
import script from "./TheWarehouse.vue?vue&type=script&lang=js"
export * from "./TheWarehouse.vue?vue&type=script&lang=js"

import "./TheWarehouse.vue?vue&type=style&index=0&id=27e5ffd0&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e5ffd0"]])

export default __exports__